export default "__VITE_ASSET__DpQVEtRN__"